var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38,
    height: 32,
    viewBox: "0 0 38 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1135_116440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.3905 0.309082L37.532 10.6213L18.766 31.9609L0 10.6213L5.14145 0.309082H32.3905Z",
    fill: "url(#paint0_linear_1135_116440)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.6211L9.88424 12.2685L18.766 31.9607L0 10.6211Z",
    fill: "url(#paint1_linear_1135_116440)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.6213L9.88424 12.2687L14.5215 0.309082H5.14145L0 10.6213Z",
    fill: "url(#paint2_linear_1135_116440)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.532 10.6211L27.6477 12.2685L18.766 31.9607L37.532 10.6211Z",
    fill: "url(#paint3_linear_1135_116440)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5324 10.6213L27.6481 12.2687L23.005 0.309082H32.3909L37.5324 10.6213Z",
    fill: "url(#paint4_linear_1135_116440)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88425 12.2686H27.6477L18.766 31.9608L9.88425 12.2686Z",
    fill: "url(#paint5_linear_1135_116440)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M27.7191 12.3273L23.0291 0.309082H5.14832L0.165161 10.5685C6.0277 14.0861 8.74325 23.8914 17.4597 21.4142L27.7191 12.3273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.30246 5.67362C7.30997 5.89245 5.52659 5.66833 5.1455 4.50798C4.75842 3.36841 5.91885 1.7281 7.91141 1.50949C9.90094 1.27302 11.8653 2.57718 12.2435 3.71968C12.6336 4.87699 11.292 5.43741 9.30246 5.67362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.18447 8.78154C3.39509 9.27971 2.63844 9.20325 2.40956 8.51833C2.1817 7.83615 2.56818 6.80422 3.35752 6.30608C4.14487 5.80549 5.02513 6.03117 5.25193 6.7137C5.48179 7.39847 4.97176 8.28093 4.18447 8.78154Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1135_116440",
    x1: 18.766,
    y1: 0.309082,
    x2: 18.766,
    y2: 31.9609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F50B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B459A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1135_116440",
    x1: 9.38299,
    y1: 10.6211,
    x2: 9.38299,
    y2: 31.9607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F50B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B459A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1135_116440",
    x1: 7.26076,
    y1: 0.309082,
    x2: 7.26076,
    y2: 12.2687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F50B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B459A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1135_116440",
    x1: 28.149,
    y1: 10.6211,
    x2: 28.149,
    y2: 31.9607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F50B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A4394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1135_116440",
    x1: 30.2687,
    y1: 0.309082,
    x2: 30.2687,
    y2: 12.2687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F50B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A4394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1135_116440",
    x1: 18.766,
    y1: 12.2686,
    x2: 18.766,
    y2: 31.9608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F50B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A4394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1135_116440"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.532,
    height: 31.6519,
    fill: "white",
    transform: "translate(0 0.309082)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.f090845b84a79a4e24ed.svg";
export { ForwardRef as ReactComponent };